<template>
  <div class="Agbtext">
            <p class="has-text-weight-bold smallspacetop is-size-4 is-size-5-mobile">Allgemeine Gesch&auml;ftsbedingungen</p>
            <p class="has-text-weight-bold is-size-5 is-size-6-mobile">1.&nbsp;Geltungsbereich</p>
            <p>
              F&uuml;r alle Bestellungen &uuml;ber unseren Online-Shop gelten
              die nachfolgenden AGB. Unser Online-Shop richtet sich
              ausschlie&szlig;lich an Verbraucher.
            </p>
            <p class="smallspacetop">
              Verbraucher ist jede nat&uuml;rliche Person, die ein
              Rechtsgesch&auml;ft zu Zwecken abschlie&szlig;t, die
              &uuml;berwiegend weder ihrer gewerblichen noch ihrer
              selbst&auml;ndigen beruflichen T&auml;tigkeit zugerechnet werden
              k&ouml;nnen. Unternehmer ist eine nat&uuml;rliche oder juristische
              Person oder eine rechtsf&auml;hige Personengesellschaft, die bei
              Abschluss eines Rechtsgesch&auml;fts in Aus&uuml;bung ihrer
              gewerblichen oder selbst&auml;ndigen beruflichen T&auml;tigkeit
              handelt.
            </p>
            <p class="has-text-weight-bold smallspacetop is-size-5 is-size-6-mobile">2.&nbsp;Vertragspartner, Vertragsschluss,
                Korrekturm&ouml;glichkeiten
            </p>
            <p class="smallspacetop">
              Der Kaufvertrag kommt zustande mit: Wilde Pracht - Christian Plöhn & Gunnar Plöhn & Birte Schmidt GbR.
            </p>
            <p class="smallspacetop">
              Mit Einstellung der Produkte in den Online-Shop geben wir ein
              verbindliches Angebot zum Vertragsschluss &uuml;ber diese Artikel
              ab. Sie k&ouml;nnen unsere Produkte zun&auml;chst unverbindlich in
              den Warenkorb legen und Ihre Eingaben vor Absenden Ihrer
              verbindlichen Bestellung jederzeit korrigieren, indem Sie die
              hierf&uuml;r im Bestellablauf vorgesehenen und erl&auml;uterten
              Korrekturhilfen nutzen. Der Vertrag kommt zustande, indem Sie
              durch Anklicken des Bestellbuttons das Angebot &uuml;ber die im
              Warenkorb enthaltenen Waren annehmen. Unmittelbar nach dem
              Absenden der Bestellung erhalten Sie noch einmal eine
              Best&auml;tigung per E-Mail. <br /><br />Die angegebenen Preise sind Endpreise zzgl. Versandkosten. Gemäß § 19 UStG erheben wir keine Umsatzsteuer und weisen diese folglich auch nicht aus (Kleinunternehmerstatus).
            </p>


            <p class="has-text-weight-bold smallspacetop is-size-5 is-size-6-mobile">
              3.&nbsp;Vertragssprache, Vertragstextspeicherung
            </p>
            <p>
              Die f&uuml;r den Vertragsschluss zur Verf&uuml;gung stehende
              Sprache ist Deutsch.
            </p>


            <p class="smallspacetop">Der Vertragstext wird von uns nicht gespeichert.</p>


            <p class="has-text-weight-bold smallspacetop is-size-5 is-size-6-mobile">4.&nbsp;Lieferbedingungen</p>

            <p>Wir liefern innerhalb Deutschlands versandkostenfrei.</p>


            <p class="smallspacetop">
              Wir liefern nur im Versandweg. Eine Selbstabholung der Ware ist
              leider nicht m&ouml;glich.
            </p>


            <p class="smallspacetop">Wir liefern nicht an Packstationen.</p>


            <p class="has-text-weight-bold smallspacetop is-size-5 is-size-6-mobile">5.&nbsp;Bezahlung</p>


            <p>
              In unserem Shop stehen Ihnen grunds&auml;tzlich die folgenden
              Zahlungsarten zur Verf&uuml;gung:
            </p>
            <p class="smallspacetop">
              <strong>Kreditkarte</strong><br />
              Mit Abgabe der Bestellung geben Sie Ihre Kreditkartendaten an.
              Nach Ihrer Legitimation als rechtm&auml;&szlig;iger Karteninhaber
              wird die Zahlungstransaktion automatisch durchgef&uuml;hrt und
              Ihre Karte belastet.
            </p>
            <p class="smallspacetop">
              <strong>PayPal</strong><br />
              Im Bestellprozess werden Sie auf die Webseite des Online-Anbieters
              PayPal weitergeleitet. Um den Rechnungsbetrag &uuml;ber PayPal
              bezahlen zu k&ouml;nnen, m&uuml;ssen Sie dort registriert sein
              bzw. sich erst registrieren, mit Ihren Zugangsdaten legitimieren
              und die Zahlungsanweisung an uns best&auml;tigen. Nach Abgabe der
              Bestellung im Shop fordern wir PayPal zur Einleitung der
              Zahlungstransaktion auf. Die Zahlungstransaktion wird durch PayPal
              unmittelbar danach automatisch durchgef&uuml;hrt. Weitere Hinweise
              erhalten Sie beim Bestellvorgang.
            </p>
            <p class="has-text-weight-bold smallspacetop is-size-5 is-size-6-mobile">6.&nbsp;Eigentumsvorbehalt</p>


            <p>
              Die Ware bleibt bis zur vollst&auml;ndigen Bezahlung unser
              Eigentum.
            </p>


            <p class="has-text-weight-bold smallspacetop is-size-5 is-size-6-mobile">7.&nbsp;Gew&auml;hrleistung und Garantien</p>

            <p>
              Es gilt das gesetzliche M&auml;ngelhaftungsrecht. Informationen zu
              gegebenenfalls geltenden zus&auml;tzlichen Garantien und deren
              genaue Bedingungen finden Sie jeweils beim Produkt und auf
              besonderen Informationsseiten im Online-Shop.
            </p>


            <p class="has-text-weight-bold smallspacetop is-size-5 is-size-6-mobile">8.&nbsp;Haftung</p>



            <p>
              F&uuml;r Anspr&uuml;che aufgrund von Sch&auml;den, die durch uns,
              unsere gesetzlichen Vertreter oder Erf&uuml;llungsgehilfen
              verursacht wurden, haften wir stets unbeschr&auml;nkt</p>
              <ul class="smallspacetop"><li class="legalli">bei Verletzung des Lebens, des K&ouml;rpers oder der
              Gesundheit</li>
              <li class="legalli">bei vors&auml;tzlicher oder grob fahrl&auml;ssiger
              Pflichtverletzung</li>
              <li class="legalli">bei Garantieversprechen, soweit vereinbart, oder</li>
              <li class="legalli">soweit der Anwendungsbereich des Produkthaftungsgesetzes
              er&ouml;ffnet ist.</li></ul>
              Bei Verletzung wesentlicher Vertragspflichten, deren
              Erf&uuml;llung die ordnungsgem&auml;&szlig;e Durchf&uuml;hrung des
              Vertrages &uuml;berhaupt erst erm&ouml;glicht und auf deren
              Einhaltung der Vertragspartner regelm&auml;&szlig;ig vertrauen
              darf, (Kardinalpflichten) durch leichte Fahrl&auml;ssigkeit von
              uns, unseren gesetzlichen Vertretern oder Erf&uuml;llungsgehilfen
              ist die Haftung der H&ouml;he nach auf den bei Vertragsschluss
              vorhersehbaren Schaden begrenzt, mit dessen Entstehung
              typischerweise gerechnet werden muss.<br />
              Im &Uuml;brigen sind Anspr&uuml;che auf Schadensersatz
              ausgeschlossen.<br />
              Wir übernehmen ausdrücklich keine Haftung für witterungsbedingte
              Beeinträchtigungen (Trockenheit, Dürre, Hagel, Starkregen o. ä.)
              beim Anwuchs und Aufwuchs der Pflanzen.
            </p>


            <p class="has-text-weight-bold smallspacetop is-size-5 is-size-6-mobile">9.&nbsp;Streitbeilegung</p>

            <p>
              Die Europ&auml;ische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit, die Sie
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank"
                >hier</a
              >
              finden. Zur Teilnahme an einem Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle sind wir nicht verpflichtet und
              nicht bereit. <br />
              <p class="smallspacetop">
                <i
                  ><a
                    target="_blank"
                    title="AGB"
                    href="https://shop.trustedshops.com/de/rechtstexte/"
                    >AGB</a
                  >
                  erstellt mit dem
                  <a
                    target="_blank"
                    title="Trusted Shops"
                    href="https://shop.trustedshops.com/de/"
                    >Trusted Shops</a
                  >
                  Rechtstexter in Kooperation mit
                  <a
                    target="_blank"
                    title="FÖHLISCH Rechtsanwälte"
                    href="https://foehlisch.com"
                    rel="nofollow"
                    >FÖHLISCH Rechtsanwälte</a
                  >.</i
                >
              </p>
            </p>
          </div>
</template>
<script>
export default {
  name: "Agbtext"
}
</script>
